import { useEffect, useState } from "react";
import add from './../../assets/Images/Request_Property/add.png';
import upload from './../../assets/Images/Request_Property/upload.png';
import deleteIcon from './../../assets/Images/Request_Property/delete.png';
import loader from './../../assets/Images/Request_Property/Loader.gif';
import './DocumentUploadForm.css';
import del from './../../assets/Images/Request_Property/delete.png';
import close from './../../assets/Images/Request_Property/close.png';
import FilePreview from '../Common/FilePreview';
import { formatReadableDate } from "../../utils/dateExtractor";

const DocumentUploadForm = ({ category, handleManualDateChange, files, handleClick, manualDate, setManualDate, handleFileUpload, addFileInput, removeFileInput, formatType, Loading, activestepper, filteredOptions, uploadErrors }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const isUploading = Loading === true || (files ?? []).some((input) => input?.loading === true);
    useEffect(() => {
        console.log(activestepper, 'activestepper')
    }, [])
    const onLoad = () => {
        setIsLoading(false);
        setHasError(false);
    };

    const onError = () => {
        setIsLoading(false);
        setHasError(true);
    }

    return (
        <div className="legal-docs">
            {formatType === 'regular' ? <label>{category}</label> : null}
            {formatType === 'regular' ?
                <div className="documents-container" style={{ justifyContent: (files ?? []).length === 1 ? 'center' : 'flex-start' }}>
                    {Loading ? (
                        <div className="loader-container">
                            <img src={loader} alt="Loading..." />
                            <p>Loading...</p>
                        </div>
                    ) : (files ?? []).map((input) => (

                        <div key={input.id} className="col-md-3 document-card">
                            <input
                                type="file"
                                id={input.id}
                                style={{ display: "none" }}
                                ref={(el) => (input.ref = el)}
                                accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv,.svg"
                                onChange={(e) => handleFileUpload(e, category, input.id)}
                            />
                            <div 
                                className="remove-upload" 
                                title="Remove Document"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    removeFileInput(category, input.id);
                                }}
                            >
                                <span className="x-icon">✕</span>
                            </div>
                            <div className={`userImage ${input.data ? 'has-file' : ''}`} onClick={() => handleClick(input.ref)}>
                                {isLoading ? (
                                    <div className="loader-container">
                                        <img src={loader} alt="Loading..." />
                                        <p>Loading...</p>
                                    </div>
                                ) : input.data ? (
                                    <div style={{ width: "100%" }}>
                                        <FilePreview
                                            url={input.data}
                                            previewUrl={input.previewUrl}
                                            width="100%"
                                            height="auto"
                                            style={{ border: 'none', background: 'transparent', padding: '0px', margin: '0' }}
                                            title="Document Viewer"
                                            fileSize={input.fileSize}
                                            onLoad={onLoad}
                                            onError={onError}
                                            isPreviewUrl={true}
                                        />
                                        {hasError && <p className="error-message">Failed to load document</p>}
                                    </div>
                                ) : (
                                    <div>
                                        <>
                                            <img src={upload} width={50} alt="Upload Icon" />
                                            <p>Upload Your Document</p>
                                        </>
                                    </div>
                                )}
                            </div>
                            {input.uploadError && (
                                <p style={{ color: 'var(--color-error)', marginTop: '8px', marginBottom: 0 }}>
                                    {input.uploadError}
                                </p>
                            )}
                        </div>
                    ))}
                    {activestepper <= 4 && (
                        <>
                            <div
                                className={`add-doc ${isUploading ? "disabled" : ""}`}
                                onClick={() => {
                                    if (!isUploading) addFileInput(category);
                                }}
                            >
                                <img src={add} width={40} alt="Add Document" />
                            </div>
                            <div>
                                {uploadErrors && (
                                    <p style={{ color: "var(--color-error)", marginBottom: "8px" }}>
                                        {uploadErrors}
                                    </p>
                                )}
                            </div>
                        </>
                    )}
                    {/* {activestepper > 4 && filteredOptions?.length > 0 && (
                        <div className="add-doc" onClick={() => addFileInput(category)}>
                            <img src={add} width={40} alt="Add Document" />
                        </div>
                    )} */}
                </div>
                :
                <div className="documents-container" style={{ justifyContent: (files ?? []).length === 1 ? 'center' : 'flex-start' }}>
                    {Loading ? (
                        <div className="loader-container">
                            <img src={loader} alt="Loading..." />
                            <p>Loading...</p>
                        </div>
                    ) : (files ?? []).map((input) => (

                        <div key={input.id} className="col-md-3 document-card">
                            <input
                                type="file"
                                id={input.id}
                                style={{ display: "none" }}
                                ref={(el) => (input.ref = el)}
                                accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv,.svg"
                                onChange={(e) => handleFileUpload(e, category, input.id)}
                            />

                            <div
                                className="remove-upload"
                                title="Remove Document"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    removeFileInput(category, input.id);
                                }}
                            >
                                <span className="x-icon">✕</span>
                            </div>
                            <div className={`userImage ${input.data ? 'has-file' : ''}`} onClick={() => handleClick(input.ref)}>
                                {isLoading ? (
                                    <div className="loader-container">
                                        <img src={loader} alt="Loading..." />
                                        <p>Loading...</p>
                                    </div>
                                ) : input.data ? (
                                    <div style={{ width: "100%" }}>
                                        <FilePreview
                                            url={input.data}
                                            previewUrl={input.previewUrl}
                                            width="100%"
                                            height="auto"
                                            style={{ border: 'none', background: 'transparent', padding: '0px', margin: '0' }}
                                            title="Document Viewer"
                                            fileSize={input.fileSize}
                                            onLoad={onLoad}
                                            onError={onError}
                                            isPreviewUrl={true}
                                        />
                                        {hasError && <p className="error-message">Failed to load document</p>}
                                    </div>
                                ) : (
                                    <div>
                                        <img src={upload} width={50} alt="Upload Icon" />
                                        <p>Upload Your Document</p>
                                    </div>
                                )}
                            </div>
                            {input.data && (
                                <div style={{ marginTop: "14px", width: "100%", paddingTop: "12px", borderTop: "1px solid #f1f5f9" }}>
                                    {input.isExtracting ? (
                                        <p style={{ color: "var(--color-turquoise-teal)", marginBottom: "6px", fontSize: "13px", fontWeight: "600", textAlign: "center" }}>Reading document date... please wait...</p>
                                    ) : !input.manualDate ? (
                                        <p style={{ color: "var(--color-error)", marginBottom: "6px", fontSize: "13px", fontWeight: "600", textAlign: "center" }}>
                                            * Date required. Please enter a date:
                                        </p>
                                    ) : null}

                                    {/* Date input */}
                                    <input
                                        type="date"
                                        max={new Date().toISOString().split("T")[0]}
                                        className="form-control"
                                        style={{
                                            width: "100%",
                                            padding: "8px 12px",
                                            borderRadius: "6px",
                                            border: !input.manualDate ? "1.5px solid var(--color-error)" : "1px solid #cbd5e1",
                                            fontSize: "14px"
                                        }}
                                        value={input.manualDate || ""}
                                        disabled={input.isExtracting}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const parts = value.split("-");
                                            if (parts[0] && parts[0].length > 4) {
                                                parts[0] = parts[0].slice(0, 4);
                                                e.target.value = parts.join("-");
                                            }
                                            handleManualDateChange("date", e.target.value, category, input.id);
                                        }}
                                    />

                                    {input.manualDate && !input.isExtracting && (
                                        <p style={{ fontSize: '13px', color: 'var(--color-turquoise-teal)', fontWeight: '600', marginTop: '6px', marginBottom: '8px', textAlign: 'center' }}>
                                            Auto-read Date: {formatReadableDate(input.manualDate)}
                                        </p>
                                    )}

                                    {/* Checkbox input */}
                                    {input.manualDate && !input.isExtracting && (
                                        <p style={{
                                            marginTop: "10px",
                                            marginBottom: "0",
                                            fontSize: "13px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "8px",
                                            padding: "6px 8px",
                                            borderRadius: "6px",
                                            background: !input.declare ? "rgba(239, 68, 68, 0.06)" : "transparent",
                                            border: !input.declare ? "1px dashed var(--color-error)" : "1px solid transparent"
                                        }}>
                                            <span style={{ color: !input.declare ? "var(--color-error)" : "var(--color-turquoise-teal)", fontWeight: "600" }}>
                                                I confirm this date is correct {!input.declare && "*"}
                                            </span>
                                            <input
                                                type="checkbox"
                                                checked={input.declare || false}
                                                style={{ cursor: "pointer", width: "16px", height: "16px", accentColor: "var(--color-turquoise-teal)" }}
                                                onChange={(e) => {
                                                    handleManualDateChange("declare", e.target.checked, category, input.id);
                                                }}
                                            />
                                        </p>
                                    )}
                                </div>
                            )}
                            {input.uploadError && (
                                <p style={{ color: 'var(--color-error)', marginTop: '8px', marginBottom: 0 }}>
                                    {input.uploadError}
                                </p>
                            )}

                        </div>
                    ))}
                    <div
                        className={`add-doc ${isUploading ? "disabled" : ""}`}
                        onClick={() => {
                            if (!isUploading) addFileInput(category);
                        }}
                    >
                        <img src={add} width={40} alt="Add Document" />
                    </div>
                </div>}
        </div>
    );
};

export default DocumentUploadForm;

